import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a6fc3052&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a6fc3052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc3052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6fc3052')) {
      api.createRecord('a6fc3052', component.options)
    } else {
      api.reload('a6fc3052', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a6fc3052&scoped=true&", function () {
      api.rerender('a6fc3052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NMV1k2jn78Dy/JS/comp/PopupBox.vue"
export default component.exports